import React, { Component } from 'react';
import { Container, Form, Row} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Goal extends Component{

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                    <Container>
                        <Form className="p-3">
                            
                            <div className="form-section">
                                <h4>Goal Setting</h4>
                                <hr />
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Strongly Disagree and
                                5-Strongly Agree...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formGoalsOrganization"
                                controlId="formGoalsOrganization"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    16. My individual goals align with the organizational goals?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formGoalsOrganization"
                                    id="formGoalsOrganization-1"
                                    defaultChecked={this.props.formGoalsOrganization === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formGoalsOrganization"
                                    id="formGoalsOrganization-2"
                                    defaultChecked={this.props.formGoalsOrganization === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formGoalsOrganization"
                                    id="formGoalsOrganization-3"
                                    defaultChecked={this.props.formGoalsOrganization === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formGoalsOrganization"
                                    id="formGoalsOrganization-4"
                                    defaultChecked={this.props.formGoalsOrganization === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formGoalsOrganization"
                                    id="formGoalsOrganization-5"
                                    defaultChecked={this.props.formGoalsOrganization === 5}
                                />
                                </Form.Group>

                                <Form.Group
                                as={Row}
                                name="formGoalsDepartment"
                                controlId="formGoalsDepartment"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    17. My individual goals align with my department's goals?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formGoalsDepartment"
                                    id="formGoalsDepartment-1"
                                    defaultChecked={this.props.formGoalsDepartment === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formGoalsDepartment"
                                    id="formGoalsDepartment-2"
                                    defaultChecked={this.props.formGoalsDepartment === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formGoalsDepartment"
                                    id="formGoalsDepartment-3"
                                    defaultChecked={this.props.formGoalsDepartment === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formGoalsDepartment"
                                    id="formGoalsDepartment-4"
                                    defaultChecked={this.props.formGoalsDepartment === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formGoalsDepartment"
                                    id="formGoalsDepartment-5"
                                    defaultChecked={this.props.formGoalsDepartment === 5}
                                />
                                </Form.Group>

                                <Form.Group
                                as={Row}
                                name="formGoalsManager"
                                controlId="formGoalsManager"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    18. My manager supports me in achieving my goals?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formGoalsManager"
                                    id="formGoalsManager-1"
                                    defaultChecked={this.props.formGoalsManager === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formGoalsManager"
                                    id="formGoalsManager-2"
                                    defaultChecked={this.props.formGoalsManager === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formGoalsManager"
                                    id="formGoalsManager-3"
                                    defaultChecked={this.props.formGoalsManager === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formGoalsManager"
                                    id="formGoalsManager-4"
                                    defaultChecked={this.props.formGoalsManager === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formGoalsManager"
                                    id="formGoalsManager-5"
                                    defaultChecked={this.props.formGoalsManager === 5}
                                />
                                </Form.Group>
                                
                            </div>
                        </Form>
                    </Container>
                </Div>
            </ThemeProvider>
        )
    }
}

export default Goal;